import { fastProgressRing, provideFASTDesignSystem } from "@microsoft/fast-components";
import { html, when } from "@microsoft/fast-element";
import { getResources } from "../../../../getResources";
import { actionMenuIcon, errorCircleIcon, pinnedStatusIcon } from "./title-bar-icons";
provideFASTDesignSystem().register(fastProgressRing());
const cardActionMenuTemplate = html `
    <fluent-widget-action-menu
        :referrerButton=${(x) => x.actionsMenuButtonElement}
        :referrerButtonRect=${(x) => x.actionsMenuButtonBoundingRect}
        :parentRect=${(x) => x.getBoundingClientRect()}
        :menuItems=${(x) => x.menuItems}
    />
`;
const lastUpdatedStatus = html `<Text class="small">${(x) => x.lastUpdated}</Text> `;
const errorSectionTemplate = html `
    <div class="errorSection">${when((x) => x.error, html `${errorCircleIcon}`)} ${when((x) => x.error, lastUpdatedStatus)}</div>
`;
const cardActionsSectionTemplate = html `
    <div class="cardActionsSection">
        ${errorSectionTemplate} ${when((x) => x.isPinned && x.showPinIcon, html `${pinnedStatusIcon}`)}
        <fluent-button
            slot="more-actions"
            appearance="neutral"
            @click=${(x, c) => x.toggleActionMenu(!x.isActionMenuOpen, c.event)}
            role="button"
            title="${(x) => getResources().WidgetContextMenu_WidgetContextMenuTooltipText}"
            aria-expand="${(x) => x.isActionMenuOpen}"
            aria-label="${(x) => getResources().WidgetContextMenu_WidgetContextMenuTooltipText}"
            ?disabled="${(x) => x.isMenuButtonDisabled}"
        >
            ${actionMenuIcon}
        </fluent-button>
    </div>
`;
const titleActivationLink = html `
    <a href=${(x) => x.activationUrl} class="titlebar-title" target="_blank" title=${(x) => x.title} @click=${(x, c) => x.onActivationUrlClick(c.event)}>
        ${(x) => x.title}
    </a>
`;
const titleWithoutLink = html `
    <Text class="titlebar-title" tabIndex="2" @click=${(x, c) => x.onTitleClick(c.event)}>
        ${(x) => x.title}
    </Text>
`;
const spinner = html `<fast-progress-ring></fast-progress-ring>`;
export const titleBarTemplate = (context, definition) => html `
    <template>
    <div class="titlebar-text">
        ${when((x) => !x.loading, html `<img class="titlebar-icon" src="${(x) => x.widgetIconUri}" />`)} ${when((x) => x.loading, spinner)}
        ${when((x) => x.activationUrl != null, titleActivationLink)}
        ${when((x) => x.activationUrl == null, titleWithoutLink)}
    </div>
        ${cardActionsSectionTemplate}
        ${when((x) => x.isActionMenuOpen, cardActionMenuTemplate)}
    </template>
`;
